package fr.frux.core.maps

import androidx.compose.runtime.Composable
import androidx.compose.runtime.Stable

enum class LocationPermissionStatus {
    NOT_REQUESTED,
    GRANTED,

    /** Refus simple : redemander affichera encore la boite de dialogue systeme. */
    DENIED,

    /** Refus definitif : redemander n'affiche plus rien, il faut passer par les reglages. */
    PERMANENTLY_DENIED,
}

/**
 * Demande de permission de localisation.
 *
 * C'est un composant d'UI et non un service injectable : sur Android la demande s'adosse a
 * `rememberLauncherForActivityResult`, qui exige une Activity et non un context applicatif.
 */
@Stable
interface LocationPermissionController {
    val status: LocationPermissionStatus

    /** Vrai quand Android recommande d'expliquer pourquoi la permission est utile. */
    val shouldExplain: Boolean

    /**
     * Vrai quand la demande peut partir des le premier affichage de la carte (pattern mobile).
     * Faux sur le web : Chrome penalise les prompts hors geste utilisateur, la demande doit
     * attendre un clic sur « ma position ».
     */
    val promptOnLaunch: Boolean get() = true

    /**
     * Vrai quand [openAppSettings] mene reellement quelque part. Faux sur le web : les reglages
     * de site du navigateur ne sont pas ouvrables par script, le bandeau ne doit pas promettre
     * un bouton « Reglages ».
     */
    val canOpenAppSettings: Boolean get() = true

    fun request()

    /**
     * Ouvre les reglages systeme de l'application.
     *
     * Seule issue apres un refus definitif, ou [request] n'affiche plus rien. N'est appelee que
     * sur [LocationPermissionStatus.PERMANENTLY_DENIED], statut qu'Android seul produit — d'ou
     * une implementation vide sur les plateformes sans permission runtime.
     */
    fun openAppSettings()
}

@Composable
expect fun rememberLocationPermissionController(): LocationPermissionController
